// extracted by mini-css-extract-plugin
export var childrenContainer = "_cl-0";
export var virtualScrollArea = "_cl-1";